<script>
    /**
     * @typedef {Object} Props
     * @property {string} [title]
     * @property {string} [icon]
     * @property {string} [associatedID]
     * @property {boolean} [hasDelete]
     * @property {boolean} [hasMove]
     * @property {boolean} [showBody]
     * @property {import('svelte').Snippet} [children]
     */
    let {
        title = '',
        icon = '',
        associatedID = '',
        hasDelete = false,
        hasMove = false,
        showBody = false,
        children,
        onDelete = () => {},
        onMoveUp = () => {},
        onMoveDown = () => {},
    } = $props();

    let isShowBody = $state(showBody);

    function toggleBody(e) {
        if (!e.target.classList.contains('icon-button')) isShowBody = !isShowBody;
    }

    function handleDeleteClick(e) {
        onDelete({
            detail: {
                associatedID,
            },
        });
    }

    function handleMoveUpClick(e) {
        onMoveUp({
            detail: {
                associatedID,
            },
        });
    }

    function handleMoveDownClick(e) {
        onMoveDown({
            detail: {
                associatedID,
            },
        });
    }
</script>


<div id={associatedID} class="form-section">
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <div onclick={toggleBody} class="section-header interactive {isShowBody ? 'open' : 'closed'}">
        {#if icon}
            <i class="material-icons" aria-hidden="true">{icon}</i>
        {/if}
        <h3>{title}</h3>
        <div class="spacer"></div>
        <div class="right-menu">
            {#if hasMove}
                <i onclick={handleMoveUpClick} class="material-icons icon-button interactive" aria-hidden="true">move_up</i>
                <i onclick={handleMoveDownClick} class="material-icons icon-button interactive" aria-hidden="true">move_down</i>
            {/if}
            {#if hasDelete}
                <i onclick={handleDeleteClick} class="material-icons icon-button interactive" aria-hidden="true">delete</i>
            {/if}
        </div>
    </div>
    {#if isShowBody}
    <div class="section-body">
        {@render children?.()}
    </div>
    {/if}
</div>


<style>
    .form-section{
        display:flex;
        flex-direction: column;
        margin:0.5rem 0.5rem 0 0.5rem;
        border-radius:0.6rem;
        border:0px solid rgba(255,255,255,0.2);

    }

    .form-section:last-of-type{
        margin-bottom:0.5rem;
    }

    .section-header{
        display:flex;
        align-items:center;
        padding:0.25rem 0.25rem 0.25rem 0.75rem;
        border-radius:0.5rem;
        background-color:rgba(255,255,255,0.2);
        color:#121111;
    }

    .section-header:hover .right-menu{
        opacity:1;
    }
    
    .section-header h3{
        font-size:1rem;
        font-weight:600;
        color:inherit;
        
        
    }

    
    .section-header>i{
        margin-right:0.75rem;
        color:inherit;
       
    }

    .section-body{
        padding:0.5rem 1rem;
        background-color:rgba(255,255,255,0.05);
        border-radius:0 0 0.5rem 0.5rem;
    }

     
    .right-menu{
        display:flex;
        align-items:center;
        opacity:0.25;
    }

    .right-menu i{
        padding:0.5rem;
        border-radius:10rem;
        color:#ddd;
    }

    .right-menu i:not(:last-of-type){
        margin-right:0.5rem;
    }

    .right-menu i:hover{
        background-color:rgba(255,255,255,0.1);
    }

    .open{
        border-radius:0.5rem 0.5rem 0 0;
    }
</style>

